module.exports = __webpack_public_path__ + "hr.5dbad14f.svg";